/**
 * MerryWink product card "Add to cart" buttons.
 * Adds the variant via the AJAX cart, refreshes the cart drawer and lets it auto-open,
 * using the same event the theme's own product form dispatches.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((el) => el.dataset.sectionId)
    .filter((value, index, values) => value && values.indexOf(value) === index);
}

async function addToCart(button) {
  const variantId = Number(button.dataset.mwAdd);
  if (!variantId || button.disabled) return;

  button.disabled = true;
  button.classList.add('is-loading');

  let resolveEvent;
  let rejectEvent;
  const promise = new Promise((resolve, reject) => {
    resolveEvent = resolve;
    rejectEvent = reject;
  });
  promise.catch(() => {});

  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product-card',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: cartSectionIds(),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add to cart');
    }

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    resolveEvent({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        sections: data.sections || undefined,
        items: cart.items,
        itemCount: cart.item_count,
        source: 'merrywink-card-cta',
        didError: false,
      },
    });

    button.classList.add('is-added');
    setTimeout(() => button.classList.remove('is-added'), 2200);
  } catch (error) {
    rejectEvent(error);
    console.warn('[MerryWink card]', error);
    const label = button.querySelector('.mw-card-cta__label');
    if (label) {
      const original = label.textContent;
      label.textContent = 'No more in stock';
      setTimeout(() => (label.textContent = original), 2500);
    }
  } finally {
    button.disabled = false;
    button.classList.remove('is-loading');
  }
}

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('[data-mw-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(button);
  },
  true
);

